import { Link } from 'react-router-dom';
import { useSiteImage } from '../lib/useSiteImage';

const ABOUT_FALLBACK = 'https://images.pexels.com/photos/11742213/pexels-photo-11742213.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900';

export default function About() {
  const aboutImage = useSiteImage('about_main', ABOUT_FALLBACK);
  return (
    <div data-testid="about-page" className="bg-white">
      <section className="pt-32 pb-12 md:pb-20 container-edge">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">About FindYourMUA</div>
        <h1 className="mt-3 font-serif text-4xl sm:text-5xl md:text-7xl leading-[1] tracking-tight max-w-4xl">
          A Curated Home for <span className="italic text-[#a465a8]">Beauty,</span> Built on Trust.
        </h1>
      </section>

      <section className="container-edge grid md:grid-cols-12 gap-10 md:gap-12 pb-20">
        <div className="md:col-span-7 min-w-0">
          <p className="font-serif text-2xl md:text-3xl leading-snug text-balance">
            FindYourMUA was created for one simple reason — discovering the right makeup artist should not feel uncertain, overwhelming, or endlessly time-consuming.
          </p>
          <p className="mt-8 text-base md:text-lg text-neutral-700 leading-relaxed">
            Brides and clients were spending hours navigating countless profiles, unsure of who to trust, while exceptionally talented artists struggled to connect with clients genuinely ready to book. We saw the gap — and decided to build the bridge.
          </p>
          <p className="mt-6 text-base md:text-lg text-neutral-700 leading-relaxed">
            FindYourMUA is a carefully curated beauty marketplace designed to make discovery effortless. From bridal transformations and engagement glam to editorial artistry and special occasion makeup, we help clients explore trusted artists through real portfolios, transparent information, and thoughtful curation.
          </p>
          <p className="mt-6 text-base md:text-lg text-neutral-700 leading-relaxed">
            Every artist featured on FindYourMUA is personally reviewed by our team based on their portfolio, professionalism, and quality of work — so every search feels a little more confident, and every booking a little more seamless.
          </p>
          <p className="mt-6 text-base md:text-lg text-neutral-700 leading-relaxed">
            We are building more than a platform. We are creating a trusted destination where artistry gets discovered, talent gets celebrated, and every client finds a look that feels truly their own.
          </p>
        </div>
        <div className="md:col-span-5 min-w-0">
          <div className="aspect-[4/5] img-zoom">
            <img src={aboutImage} alt="Indian bridal beauty" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-[#ffefd1] py-20 md:py-28">
        <div className="container-edge grid md:grid-cols-3 gap-12">
          {[
            { n: 'Verified', t: 'Every artist is personally reviewed by our team — portfolio, professionalism, and quality of work.' },
            { n: 'Curated', t: 'Editorial standards, not just listings. A trusted destination where artistry gets discovered and talent gets celebrated.' },
            { n: 'Connected', t: 'Direct WhatsApp lines, no middlemen. Real portfolios, transparent information, seamless booking.' },
          ].map(b => (
            <div key={b.n}>
              <div className="font-serif text-5xl text-[#eb5381]">{b.n}.</div>
              <p className="mt-5 text-base md:text-lg text-neutral-700 leading-relaxed">{b.t}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container-edge py-20 md:py-28 text-center">
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight">Ready to find yours?</h2>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/artists" className="inline-flex items-center justify-center bg-[#eb5381] hover:bg-[#d64570] text-white px-9 py-4 text-[11px] uppercase tracking-[0.25em] transition-colors">Discover Artists</Link>
          <Link to="/contact" className="inline-flex items-center justify-center border border-black hover:bg-black hover:text-white px-9 py-4 text-[11px] uppercase tracking-[0.25em] transition-colors">Skip The Search</Link>
        </div>
      </section>
    </div>
  );
}
